import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import OurNews from '../views/OurNews.vue';
import SinglePost from '../views/SinglePost.vue';
import HowWeWork from '../views/HowWeWork.vue';
import OurHistory from '../views/OurHistory.vue';
import OurOrganization from '../views/OurOrganization.vue';
import Contact from '../views/Contact.vue';
import Don from '../views/Don.vue';
import JoinUs from '../views/JoinUs.vue';
import OurRessources from '../views/OurRessources.vue';
import Discours from '../views/Discours.vue';
import OurTeam from '../views/OurTeam.vue';
import GhanaHub from '../views/GhanaHub.vue';
import Search from '../views/Search.vue';
import OurProjects from '../views/OurProjects.vue';
import OurBlogs from '../views/OurBlogs.vue';
import NotFound from '../views/NotFound.vue';
import Covid19 from '../views/Covid19';

import i18n from '../i18n';

Vue.use(VueRouter);

var userLang = navigator.language || navigator.userLanguage;

var defaultLang = userLang.substring(0, 2);

i18n.locale = defaultLang;

var redirect = '/' + defaultLang + '/' + `${i18n.t('routes.home')}`;

const routes = [
  {
    path: '/',
    redirect: redirect
  },
  {
    path: '/:lang',
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: 'home',
        name: 'homeEn',
        component: Home
      },
      {
        path: 'accueil',
        name: 'homeFr',
        component: Home
      },
      {
        path: 'how-we-work',
        name: 'howWeWorkEn',
        component: HowWeWork
      },
      {
        path: 'ce-que-nous-faisons',
        name: 'howWeWorkFr',
        component: HowWeWork
      },
      {
        path: 'our-organization',
        name: 'ourOrganizationEn',
        component: OurOrganization
      },
      {
        path: 'notre-organisation',
        name: 'ourOrganizationFr',
        component: OurOrganization
      },
      {
        path: 'our-history',
        name: 'ourHistoryEn',
        component: OurHistory
      },
      {
        path: 'notre-histoire',
        name: 'ourHistoryFr',
        component: OurHistory
      },
      {
        path: 'our-team',
        name: 'ourTeamEn',
        component: OurTeam
      },
      {
        path: 'notre-equipe',
        name: 'ourTeamFr',
        component: OurTeam
      },
      {
        path: 'ghana-hub',
        name: 'ghanaHubEn',
        component: GhanaHub
      },
      {
        path: 'ghana-hub',
        name: 'ghanaHubFr',
        component: GhanaHub
      },
      {
        path: 'Initiative-Covid-19',
        name: 'covid19En',
        component: Covid19
      },
      {
        path: 'Initiative-Covid-19',
        name: 'covid19Fr',
        component: Covid19
      },
      {
        path: 'our-news',
        name: 'ourNewsEn',
        component: OurNews
      },
      {
        path: 'nos-nouvelles',
        name: 'ourNewsFr',
        component: OurNews
      },
      {
        path: 'our-blogs',
        name: 'ourBlogsEn',
        component: OurBlogs
      },
      {
        path: 'nos-blogs',
        name: 'ourBlogsFr',
        component: OurBlogs
      },
      {
        path: 'join-afrik-eveil',
        name: 'JoinUsEn',
        component: JoinUs
      },
      {
        path: 'rejoindre-afrik-eveil',
        name: 'JoinUsFr',
        component: JoinUs
      },
      {
        path: 'donation',
        name: 'donEn',
        component: Don
      },
      {
        path: 'donation',
        name: 'donFr',
        component: Don
      },
      {
        path: 'our-projects',
        name: 'ourProjectsEn',
        component: OurProjects
      },
      {
        path: 'nos-projets',
        name: 'ourProjectsFr',
        component: OurProjects
      },
      {
        path: 'contact-us',
        name: 'contactEn',
        component: Contact
      },
      {
        path: 'contactez-nous',
        name: 'contactFr',
        component: Contact
      },
      {
        path: 'our-ressources',
        name: 'ourRessourcesEn',
        component: OurRessources
      },
      {
        path: 'nos-ressources',
        name: 'ourRessourcesFr',
        component: OurRessources
      },
      {
        path: 'speech-at-the-House-of-lords',
        name: 'discoursEn',
        component: Discours
      },
      {
        path: 'discours-à-la-chambre-des-seigneurs',
        name: 'discoursFr',
        component: Discours
      },
      {
        path: 'search-results/:slug',
        name: 'SearchEn',
        component: Search
      },
      {
        path: 'résultats-de-recherche/:slug',
        name: 'SearchFr',
        component: Search
      },
      {
        path: ':type/:slug',
        name: 'SinglePost',
        component: SinglePost,
        props: {
          type: String
        }
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
